import React, {Fragment, useState, useEffect} from 'react'
import PropTypes from 'prop-types';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';

import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { Divider } from '@mui/material';
import Avatar from '@mui/material/Avatar';

import ListItem from '@mui/material/ListItem';
import ListItemText from '@mui/material/ListItemText';
import ListItemAvatar from '@mui/material/ListItemAvatar';
import Chip from '@mui/material/Chip';
import LinearProgress from '@mui/material/LinearProgress';

import List from '@mui/material/List';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListSubheader from '@mui/material/ListSubheader';
import AccountBalanceWalletIcon from '@mui/icons-material/AccountBalanceWallet';
import ListItemButton from '@mui/material/ListItemButton';
import CreditScoreIcon from '@mui/icons-material/CreditScore';
import LockClockIcon from '@mui/icons-material/LockClock';
import { useParams } from 'react-router-dom';
import { useSelector } from 'react-redux';
import Popover from '@mui/material/Popover';
import HelpIcon from '@mui/icons-material/Help';
import IconButton from '@mui/material/IconButton';
import Alert from '@mui/material/Alert';
import Button from '@mui/material/Button';
import AddchartIcon from '@mui/icons-material/Addchart';
import { useNavigate } from 'react-router-dom';

import { setCopyings } from '../../request/Analysis/hitorySlice';
import { useDispatch } from 'react-redux';
import { useMutation } from "react-query";
import apiClient from "../../request/http-common";
import { Currency } from '@depay/local-currency';

import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';
import InputLabel from '@mui/material/InputLabel';
import FormControl from '@mui/material/FormControl';
import OutlinedInput from '@mui/material/OutlinedInput';


import { AdvancedRealTimeChart } from "react-ts-tradingview-widgets";

import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import Slide from '@mui/material/Slide';

// Professional icons for trade details
import TrendingUpIcon from '@mui/icons-material/TrendingUp';
import TrendingDownIcon from '@mui/icons-material/TrendingDown';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import ShowChartIcon from '@mui/icons-material/ShowChart';
import CurrencyBitcoinIcon from '@mui/icons-material/CurrencyBitcoin';
import BusinessIcon from '@mui/icons-material/Business';
import CurrencyExchangeIcon from '@mui/icons-material/CurrencyExchange';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import { styled } from '@mui/material/styles';

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

// Styled components for professional trade cards
const TradeCard = styled(Card)(({ theme }) => ({
  background: 'linear-gradient(135deg, rgba(22, 26, 30, 0.95) 0%, rgba(30, 35, 40, 0.95) 100%)',
  border: '1px solid rgba(255, 255, 255, 0.1)',
  borderRadius: '12px',
  marginBottom: '12px',
  transition: 'all 0.3s ease',
  '&:hover': {
    borderColor: 'rgba(247, 147, 26, 0.3)',
    boxShadow: '0 4px 20px rgba(0, 0, 0, 0.3)',
  }
}));

const StatBox = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  padding: '8px 12px',
  background: 'rgba(255, 255, 255, 0.03)',
  borderRadius: '8px',
  minWidth: '80px',
}));

const CopySingle = () => {
  
  // Helper function to get TradingView chart symbol based on asset type
  const getChartSymbol = (trade) => {
    const currency = trade.currency || 'EUR/USD';
    const assetType = trade.asset_type || 'forex';
    
    switch (assetType) {
      case 'crypto':
        const cryptoSymbol = currency.replace('/', '');
        return `BINANCE:${cryptoSymbol}`;
      
      case 'stocks':
        const stockSymbol = currency.replace('/', '');
        return `NASDAQ:${stockSymbol}`;
      
      case 'forex':
      default:
        const forexSymbol = currency.replace('/', '');
        return `FX:${forexSymbol}`;
    }
  };

  // Helper function to get asset type icon
  const getAssetIcon = (assetType) => {
    switch (assetType) {
      case 'crypto':
        return <CurrencyBitcoinIcon sx={{ fontSize: 16, color: '#F7931A' }} />;
      case 'stocks':
        return <BusinessIcon sx={{ fontSize: 16, color: '#4CAF50' }} />;
      case 'forex':
      default:
        return <CurrencyExchangeIcon sx={{ fontSize: 16, color: '#2196F3' }} />;
    }
  };

  // Helper function to get asset type color
  const getAssetColor = (assetType) => {
    switch (assetType) {
      case 'crypto':
        return { bg: 'rgba(247, 147, 26, 0.15)', color: '#F7931A' };
      case 'stocks':
        return { bg: 'rgba(76, 175, 80, 0.15)', color: '#4CAF50' };
      case 'forex':
      default:
        return { bg: 'rgba(33, 150, 243, 0.15)', color: '#2196F3' };
    }
  };
  
  const user = useSelector((state) => state.user.user);
  const appMode = useSelector((state) => state.mode.mode);

  const params = useParams();
  const dispatch = useDispatch();
  const [rate, setRate] = useState(1);

  const [traderId, settraderId] = useState();
  const [selectedtrader, setSelectedtrader] = useState('');
  const [source, setSource] = useState('');
  const [proportion, setProportion] = useState('');
  const [error, setErros] = useState('');
  const navigate = useNavigate();

  const callRate = async()=> {
    if(user.currency === 'USD'){
      setRate(1);
    }else{
      await Currency.fromUSD({ amount: 1 }).then(amount=>{
        setRate(amount.amount);
       });
    }  
};



  const traders = useSelector((state) => state.traders.traders);
  const getDate = (date) =>new Date(date).toLocaleString('en-GB', {
    hour12: false,
  });
  function CustomTabPanel(props) {
    const { children, value, index, ...other } = props;
  
    return (
      <div
        role="tabpanel"
        hidden={value !== index}
        id={`simple-tabpanel-${index}`}
        aria-labelledby={`simple-tab-${index}`}
        {...other}
      >
        {value === index && (
          <Box sx={{ p: 1 }}>
            <Typography>{children}</Typography>
          </Box>
        )}
      </div>
    );
  }

  function a11yProps(index) {
    return {
      id: `simple-tab-${index}`,
      'aria-controls': `simple-tabpanel-${index}`,
    };
  }

  const calcPercentage = (profit, loss) => {
    let total = parseFloat(profit) + parseFloat(loss);
    let percent = profit/total;

    return percent * 100;

 }
 
  const [value, setValue] = React.useState(0);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };
  const formatPrice = (amount)=> new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD', currencySign: 'standard' }).format(amount);

 

  const { isLoading: isInvesting, mutate: postInvestment } = useMutation(
    async () => {
      return await apiClient.post(`/api/complete-copy`, {
        copier_id: traderId
      });
    },
    {
      onSuccess: (res) => {
          if (res.data.status === 'success') {
            localStorage.setItem('notification', JSON.stringify({message : `${res.data.message}`, 'type': 'success' }));
            const event = new Event('newMessage');
            window.dispatchEvent(event);
            dispatch(setCopyings(res.data.investments));
            setTimeout(() => {
              navigate('/copy-history');
            }, 2000);
          }            
      },
      onError: (err) => {
            if (err.response?.data.length) {
              let myerror = err.response?.data || err;         
          setErros(myerror.errors)               
          }else{
              let errorMessage = err.response?.data.message || err ;
              localStorage.setItem('notification', JSON.stringify({message : `${errorMessage}`, 'type': 'error' }));
              const event = new Event('newMessage');
              window.dispatchEvent(event);
          }
      },
    }
  );

  
    const [open, setOpen] = React.useState(false);
    const investments = useSelector((state) => state.history.copyings);

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <div style={{marginTop: '75px'}}>

      {investments.map(copier => (
        parseInt(copier.id) === parseInt(params.id) &&
        
        <Fragment key={copier.id}>
        <Grid container px={2} mt={4}  mb={4} rowSpacing={2} columnSpacing={{ xs: 1, sm: 2, md: 3 }}>
          <Grid item xs={12} md={6}>
            <Box sx={{display:'flex', justifyContent: 'space-evenly', alignItems: 'center'}}>

              <ListItem alignItems="flex-start" mb={0}>
                <ListItemAvatar>
                  <Avatar alt="trader" src={copier.trader.image} />
                </ListItemAvatar>
                <ListItemText
                  primary={copier.trader.trader_name}
                  secondary={copier.trader.level}
                />
              </ListItem>
              {copier.status === 'completed' ?
              <Button disabled fullWidth={true} size="large" color='error' variant="contained">
                stoped 
              </Button>
              :
              <Button fullWidth={true} size="large" color='error' variant="contained" 
              onClick={()=> {
                handleClickOpen();
                settraderId(copier.id);}}
              >
              stop copying
              </Button>
              }
              
                
            </Box>
            <Divider/>
            </Grid>
          </Grid>
          
              <Grid container  sx={{ marginTop: '-15px'}} px={2} mt={4}  mb={4} rowSpacing={2} columnSpacing={{ xs: 1, sm: 2, md: 3 }}>
                <Grid item xs={12} md={6}>
                  <Box sx={{ width: '100%' }}>

                    <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                      <Tabs value={value} onChange={handleChange} aria-label="basic tabs example" centered>
                        <Tab label="Summary" {...a11yProps(0)} />
                        <Tab label="Trades" {...a11yProps(1)} />
                      </Tabs>
                    </Box>

                    <CustomTabPanel value={value} index={0}>
                      {/* summary content starts here */}

                      <Card sx={{ borderRadius: '9px', height: '100%', paddingX: '10px', bgcolor: '#36492d'}}>
                        <CardContent sx={{ paddingY: '12px', paddingX: '5px'}}>
                            <Box sx={{display: 'flex', justifyContent: 'space-between', alignItems: 'center', paddingY: '10px'}}>
                                <Typography sx={{fontSize: 12, textTransform: 'capitalize', marginLeft: '10px'  }} gutterBottom variant="subtitle2" component="div">
                                    Amount Invested
                                </Typography>

                                <Typography sx={{fontSize: 16, textTransform: 'capitalize', marginLeft: '10px'  }} gutterBottom variant="subtitle2" component="div">
                                    {formatPrice(copier.amount)}
                                </Typography>
                            </Box>
                            <Divider/>

                            <Box sx={{display: 'flex', justifyContent: 'space-between', alignItems: 'center', paddingY: '10px'}}>
                                <Box>
                                    {parseInt(copier.trader.risk_score) < 3  &&
                                    <Chip label={`No Risk`} color="success" /> 

                                    }
                                    {(parseInt(copier.trader.risk_score) > 2 && parseInt(copier.risk_score) < 5 )&& 
                                    <Chip label={`Low Risk`} color="warning" /> 
                                    }
                                    {parseInt(copier.trader.risk_score) > 4 &&
                                    <Chip label={`Medium Risk`} color="error" /> 
                                    }
                                </Box>

                                <Box>
                                    <IconButton color="secondary" aria-label="add an alarm">
                                      <HelpIcon />
                                    </IconButton>
                                </Box>
                                
                            </Box>
                            <Divider/>

                            <Box sx={{display: 'flex', justifyContent: 'space-between', alignItems: 'center', paddingY: '10px'}}>
                                <Typography sx={{fontSize: 12, textTransform: 'capitalize', marginLeft: '10px'  }} gutterBottom variant="subtitle2" component="div">
                                    Proportion
                                </Typography>

                                <Typography sx={{fontSize: 12, textTransform: 'capitalize', marginLeft: '10px'  }} gutterBottom variant="caption" component="div">
                                    X{copier.proportion}
                                </Typography>
                            </Box>  
                            <Divider/>

                            <Box sx={{display: 'flex', justifyContent: 'space-between', alignItems: 'center', paddingY: '10px'}}>
                                <Typography sx={{fontSize: 12, textTransform: 'capitalize', marginLeft: '10px'  }} gutterBottom variant="subtitle2" component="div">
                                    Gain
                                </Typography>

                                <Typography sx={{fontSize: 12, textTransform: 'capitalize', marginLeft: '10px'  }} gutterBottom variant="caption" component="div">
                                    {copier.gain}%
                                </Typography>
                            </Box>  
                            <Divider/>

                            <Box sx={{display: 'flex', justifyContent: 'space-between', alignItems: 'center', paddingY: '10px'}}>
                                <Typography sx={{fontSize: 12, textTransform: 'capitalize', marginLeft: '10px'  }} gutterBottom variant="subtitle2" component="div">
                                    Profit
                                </Typography>

                                <Typography sx={{fontSize: 12, textTransform: 'capitalize', marginLeft: '10px'  }} gutterBottom variant="caption" component="div">
                                    {formatPrice(copier.profit)}
                                </Typography>
                            </Box>  
                            <Divider/>

                            
                            {/* <Box sx={{display: 'flex', justifyContent: 'space-between', alignItems: 'center', paddingY: '10px', alignContent: 'center'}}>
                                <Box>
                                    <Typography my={0} variant="caption" color="text.secondary">
                                        Equity
                                    </Typography>
                                    <Typography sx={{ color: '#09b509', fontWeight: 'bold', fontSize: 16, textTransform: 'capitalize'  }} gutterBottom variant="subtitle2" component="div">
                                    {formatPrice(copier.equity)}
                                </Typography>
                                </Box>

                                <Box>
                                    <Typography my={0} variant="caption" color="text.secondary">
                                        Commission
                                    </Typography>
                                    <Typography sx={{ fontWeight: 'bold', fontSize: 16, textTransform: 'capitalize'  }} gutterBottom variant="subtitle2" component="div">
                                    {(copier.trader.commission)}%
                                </Typography>
                                </Box>

                                <Box>
                                    <Typography my={0} variant="caption" color="text.secondary">
                                        Floating Profit
                                    </Typography>
                                    <Typography sx={{fontWeight: 'bold', fontSize: 16, textTransform: 'capitalize'  }} gutterBottom variant="subtitle2" component="div">
                                    {formatPrice(copier.floating_profit)}
                                    </Typography>
                                </Box>
                            </Box> */}

                    </CardContent>
                    </Card>
                      
                      {/* summary content stops here */}
                    </CustomTabPanel>

                    <CustomTabPanel value={value} index={1}>
                      {copier.trader.trades && copier.trader.trades.length > 0 ? (
                        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
                          {/* Trade Stats Summary */}
                          <Box sx={{ 
                            display: 'flex', 
                            gap: 2, 
                            flexWrap: 'wrap', 
                            justifyContent: 'center',
                            p: 2,
                            background: 'linear-gradient(135deg, rgba(247, 147, 26, 0.1) 0%, rgba(247, 147, 26, 0.05) 100%)',
                            borderRadius: '12px',
                            border: '1px solid rgba(247, 147, 26, 0.2)'
                          }}>
                            <StatBox>
                              <Typography variant="caption" sx={{ color: 'text.secondary', fontSize: '10px' }}>Total Trades</Typography>
                              <Typography variant="h6" sx={{ fontWeight: 700, color: '#F7931A' }}>
                                {copier.trader.trades.length}
                              </Typography>
                            </StatBox>
                            <StatBox>
                              <Typography variant="caption" sx={{ color: 'text.secondary', fontSize: '10px' }}>Win Rate</Typography>
                              <Typography variant="h6" sx={{ fontWeight: 700, color: '#4CAF50' }}>
                                {Math.round((copier.trader.trades.filter(t => t.amount > 0).length / copier.trader.trades.length) * 100)}%
                              </Typography>
                            </StatBox>
                            <StatBox>
                              <Typography variant="caption" sx={{ color: 'text.secondary', fontSize: '10px' }}>Net Profit</Typography>
                              <Typography variant="h6" sx={{ 
                                fontWeight: 700, 
                                color: copier.trader.trades.reduce((sum, t) => sum + parseFloat(t.amount), 0) >= 0 ? '#4CAF50' : '#f44336'
                              }}>
                                {formatPrice(copier.trader.trades.reduce((sum, t) => sum + parseFloat(t.amount), 0))}
                              </Typography>
                            </StatBox>
                          </Box>

                          {/* Trade List */}
                          {copier.trader.trades.map((trade, index) => (
                            <TradeCard key={trade.id || index}>
                              <Accordion 
                                sx={{ 
                                  background: 'transparent',
                                  boxShadow: 'none',
                                  '&:before': { display: 'none' }
                                }}
                              >
                                <AccordionSummary
                                  expandIcon={<ExpandMoreIcon sx={{ color: 'rgba(255,255,255,0.7)' }} />}
                                  sx={{ padding: '12px 16px' }}
                                >
                                  <Grid container alignItems="center" spacing={1}>
                                    {/* Left: Trade Type & Currency */}
                                    <Grid item xs={7} sm={6}>
                                      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
                                        <Box sx={{
                                          width: 36,
                                          height: 36,
                                          borderRadius: '8px',
                                          display: 'flex',
                                          alignItems: 'center',
                                          justifyContent: 'center',
                                          background: trade.trade_type === 'BUY' 
                                            ? 'rgba(76, 175, 80, 0.2)' 
                                            : 'rgba(244, 67, 54, 0.2)',
                                        }}>
                                          {trade.trade_type === 'BUY' 
                                            ? <TrendingUpIcon sx={{ color: '#4CAF50', fontSize: 20 }} />
                                            : <TrendingDownIcon sx={{ color: '#f44336', fontSize: 20 }} />
                                          }
                                        </Box>
                                        <Box>
                                          <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
                                            <Typography variant="subtitle1" sx={{ fontWeight: 700, fontSize: '0.95rem' }}>
                                              {trade.currency}
                                            </Typography>
                                            {trade.asset_type && (
                                              <Chip
                                                icon={getAssetIcon(trade.asset_type)}
                                                label={trade.asset_type}
                                                size="small"
                                                sx={{
                                                  height: '20px',
                                                  fontSize: '10px',
                                                  textTransform: 'capitalize',
                                                  bgcolor: getAssetColor(trade.asset_type).bg,
                                                  color: getAssetColor(trade.asset_type).color,
                                                  '& .MuiChip-icon': { fontSize: 12 }
                                                }}
                                              />
                                            )}
                                          </Box>
                                          <Typography variant="caption" sx={{ color: 'text.secondary', fontSize: '11px' }}>
                                            #{trade.order_id}
                                          </Typography>
                                        </Box>
                                      </Box>
                                    </Grid>

                                    {/* Right: Status & Profit/Loss */}
                                    <Grid item xs={5} sm={6}>
                                      <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-end' }}>
                                        <Chip 
                                          label={trade.status}
                                          size="small"
                                          sx={{
                                            height: '20px',
                                            fontSize: '10px',
                                            textTransform: 'capitalize',
                                            bgcolor: trade.status === 'closed' ? 'rgba(156, 39, 176, 0.2)' : 'rgba(33, 150, 243, 0.2)',
                                            color: trade.status === 'closed' ? '#BA68C8' : '#64B5F6',
                                            mb: 0.5
                                          }}
                                        />
                                        <Typography 
                                          variant="h6" 
                                          sx={{ 
                                            fontWeight: 700,
                                            fontSize: '1rem',
                                            color: trade.amount > 0 ? '#4CAF50' : '#f44336'
                                          }}
                                        >
                                          {trade.amount > 0 ? '+' : ''}{formatPrice(trade.amount)}
                                        </Typography>
                                      </Box>
                                    </Grid>
                                  </Grid>
                                </AccordionSummary>

                                <AccordionDetails sx={{ padding: '0 16px 16px' }}>
                                  <Divider sx={{ mb: 2, borderColor: 'rgba(255,255,255,0.1)' }} />
                                  
                                  {/* Trade Details Grid */}
                                  <Grid container spacing={2} sx={{ mb: 2 }}>
                                    <Grid item xs={6} sm={3}>
                                      <Box sx={{ display: 'flex', flexDirection: 'column' }}>
                                        <Typography variant="caption" sx={{ color: 'text.secondary', fontSize: '10px' }}>Open Price</Typography>
                                        <Typography variant="body2" sx={{ fontWeight: 600 }}>{trade.open_price}</Typography>
                                      </Box>
                                    </Grid>
                                    <Grid item xs={6} sm={3}>
                                      <Box sx={{ display: 'flex', flexDirection: 'column' }}>
                                        <Typography variant="caption" sx={{ color: 'text.secondary', fontSize: '10px' }}>Close Price</Typography>
                                        <Typography variant="body2" sx={{ fontWeight: 600 }}>{trade.close_price}</Typography>
                                      </Box>
                                    </Grid>
                                    <Grid item xs={6} sm={3}>
                                      <Box sx={{ display: 'flex', flexDirection: 'column' }}>
                                        <Typography variant="caption" sx={{ color: 'text.secondary', fontSize: '10px' }}>Open Time</Typography>
                                        <Typography variant="body2" sx={{ fontWeight: 600, fontSize: '11px' }}>{getDate(trade.open_time)}</Typography>
                                      </Box>
                                    </Grid>
                                    <Grid item xs={6} sm={3}>
                                      <Box sx={{ display: 'flex', flexDirection: 'column' }}>
                                        <Typography variant="caption" sx={{ color: 'text.secondary', fontSize: '10px' }}>Close Time</Typography>
                                        <Typography variant="body2" sx={{ fontWeight: 600, fontSize: '11px' }}>{getDate(trade.close_time)}</Typography>
                                      </Box>
                                    </Grid>

                                    {/* Additional Trade Details */}
                                    {trade.leverage && (
                                      <Grid item xs={6} sm={3}>
                                        <Box sx={{ display: 'flex', flexDirection: 'column' }}>
                                          <Typography variant="caption" sx={{ color: 'text.secondary', fontSize: '10px' }}>Leverage</Typography>
                                          <Typography variant="body2" sx={{ fontWeight: 600, color: '#F7931A' }}>
                                            {trade.leverage}x
                                          </Typography>
                                        </Box>
                                      </Grid>
                                    )}
                                    {trade.lot_size && (
                                      <Grid item xs={6} sm={3}>
                                        <Box sx={{ display: 'flex', flexDirection: 'column' }}>
                                          <Typography variant="caption" sx={{ color: 'text.secondary', fontSize: '10px' }}>Lot Size</Typography>
                                          <Typography variant="body2" sx={{ fontWeight: 600 }}>{trade.lot_size}</Typography>
                                        </Box>
                                      </Grid>
                                    )}
                                    {trade.pips && (
                                      <Grid item xs={6} sm={3}>
                                        <Box sx={{ display: 'flex', flexDirection: 'column' }}>
                                          <Typography variant="caption" sx={{ color: 'text.secondary', fontSize: '10px' }}>Pips</Typography>
                                          <Typography variant="body2" sx={{ 
                                            fontWeight: 600,
                                            color: parseFloat(trade.pips) >= 0 ? '#4CAF50' : '#f44336'
                                          }}>
                                            {trade.pips > 0 ? '+' : ''}{trade.pips}
                                          </Typography>
                                        </Box>
                                      </Grid>
                                    )}
                                    {trade.commission && (
                                      <Grid item xs={6} sm={3}>
                                        <Box sx={{ display: 'flex', flexDirection: 'column' }}>
                                          <Typography variant="caption" sx={{ color: 'text.secondary', fontSize: '10px' }}>Commission</Typography>
                                          <Typography variant="body2" sx={{ fontWeight: 600 }}>${trade.commission}</Typography>
                                        </Box>
                                      </Grid>
                                    )}
                                  </Grid>

                                  {/* Entry Reason */}
                                  {trade.entry_reason && (
                                    <Box sx={{ 
                                      display: 'flex', 
                                      alignItems: 'flex-start', 
                                      gap: 1, 
                                      p: 1.5, 
                                      bgcolor: 'rgba(33, 150, 243, 0.1)',
                                      borderRadius: '8px',
                                      mb: 2
                                    }}>
                                      <InfoOutlinedIcon sx={{ color: '#64B5F6', fontSize: 18, mt: 0.2 }} />
                                      <Box>
                                        <Typography variant="caption" sx={{ color: '#64B5F6', fontWeight: 600 }}>Entry Reason</Typography>
                                        <Typography variant="body2" sx={{ color: 'text.secondary', fontSize: '12px' }}>
                                          {trade.entry_reason}
                                        </Typography>
                                      </Box>
                                    </Box>
                                  )}

                                  {/* TradingView Chart */}
                                  <Box sx={{ 
                                    borderRadius: '8px', 
                                    overflow: 'hidden',
                                    border: '1px solid rgba(255,255,255,0.1)'
                                  }}>
                                    <AdvancedRealTimeChart
                                      symbol={getChartSymbol(trade)}
                                      interval="1"
                                      timezone="Etc/UTC"
                                      theme={appMode}
                                      locale="en"
                                      hide_top_toolbar={true}
                                      enable_publishing={false}
                                      save_image={false}
                                      hide_side_toolbar={true}
                                      container_id={`copy-chart-${trade.id || index}`}
                                      isTransparent={true}
                                      height={350}
                                      width="100%"
                                    />
                                  </Box>
                                  {appMode === 'dark' ? 
                                    <Box sx={{ height: '20px', backgroundColor: '#161A1E', transform: 'translate(0px, -25px)', position: 'relative', zIndex: 10 }} />
                                    :
                                    <Box sx={{ height: '20px', backgroundColor: 'white', transform: 'translate(0px, -25px)', position: 'relative', zIndex: 10 }} />
                                  }
                                </AccordionDetails>
                              </Accordion>
                            </TradeCard>
                          ))}
                        </Box>
                      ) : (
                        <Alert 
                          severity="info" 
                          sx={{ 
                            bgcolor: 'rgba(33, 150, 243, 0.1)',
                            border: '1px solid rgba(33, 150, 243, 0.3)',
                            borderRadius: '12px'
                          }}
                        >
                          <Typography variant="body2">
                            No trade history available yet. Trades will appear here as the trader executes positions.
                          </Typography>
                        </Alert>
                      )}
                    </CustomTabPanel>
                  </Box>
              </Grid>
          </Grid>
        </Fragment>

      ))}



       
      <Dialog
        
        open={open}
        TransitionComponent={Transition}
        keepMounted
        onClose={handleClose}
        aria-describedby="alert-dialog-slide-description"
      >
        {/* <DialogTitle sx={{textAlign: 'center'}}>{"FUND YOUR WALLET"}</DialogTitle> */}

        <DialogContent>

          <DialogContentText sx={{textAlign: 'center'}} mb={2} id="alert-dialog-slide-description">
          Are you sure you want to stop copying this trader?
                     
          </DialogContentText>

          <Box sx={{display: 'flex', justifyContent: 'space-between', marginTop: '15px'}}>
            
          <Button onClick={handleClose} fullWidth={false} size="small" color="error" variant="contained"> 
            Cancel
          </Button> 

          <Button onClick={postInvestment} fullWidth={false} size="small" color="primary" variant="contained"> 
            {isInvesting ? 'Stoping...' : 'Stop Copying'}  
          </Button>         
          </Box> 

               
          
        </DialogContent>
        
      </Dialog>
    
    </div>
  )
}

export default CopySingle
